const { cxt } = require('./context');

const {
    common,
} = require('../schema');

const {
    feeConfiguration,
} = common;

/**
 * Validates the Fee Configuration
 * @type {Array<cxt>}
 * @memberof validators
 */
const feeConfigurationValidator = [
    cxt('schema', { schema: feeConfiguration, opts: { nestedErrors: true } }),
];

module.exports = {
    feeConfiguration: feeConfigurationValidator,
};
